import { Module } from 'vuex';
import { RootState } from '../store';
import { actions } from '../actions/feedback.actions';
import { mutations } from '../mutations/feedback.mutations';
import { IFeature } from '@/types/Feature';

export const namespace = 'feedback';

export interface IFeedbackState {
  isLoading: boolean;
  features: IFeature[];
}

export const state: IFeedbackState = {
  isLoading: false,
  features: [],
};

export const feedback: Module<IFeedbackState, RootState> = {
  actions,
  mutations,
  namespaced: true,
  state,
};
